var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMilestoneHero1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 293,
    viewBox: "0 0 201 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3143 196.762C47.7694 188.893 30.0109 174.558 21.4232 151.343C20.6095 149.131 10.8086 121.805 20.1085 115.046C26.1945 110.613 36.1937 118.125 58.3921 126.594C75.7927 133.238 90.8628 136.729 101.26 138.661",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3143 196.762C47.7694 188.893 30.0109 174.558 21.4232 151.343C20.6095 149.131 10.8086 121.805 20.1085 115.046C26.1945 110.613 36.1937 118.125 58.3921 126.594C75.7927 133.238 90.8628 136.729 101.26 138.661",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.605 35.767C96.4397 43.0012 25.759 147.969 63.5546 222.145C96.1331 286.084 190.712 290.619 246.702 270.699C295.122 253.464 338.745 209.392 330.916 191.996C325.404 179.773 294.817 181.526 269.904 184.916C271.068 173.528 271.642 160.179 270.816 145.313C269.848 127.861 267.184 112.611 264.155 100.081C259.381 90.4726 243.414 61.4337 208.615 45.5948C204.253 43.6056 180.359 33.0785 157.617 35.7678L157.605 35.767Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7574 159.147L94.7686 159.147C107.731 160.023 118.948 150.224 119.824 137.262L120.111 133.011C120.986 120.049 111.188 108.832 98.2258 107.956L98.2145 107.955C85.2523 107.08 74.0347 116.878 73.1593 129.841L72.8723 134.091C71.9969 147.054 81.7952 158.271 94.7574 159.147Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3104 147.108C99.1487 147.502 104.336 141.095 104.896 132.797C105.457 124.499 101.178 117.453 95.3397 117.059C89.5014 116.664 84.3143 123.071 83.7539 131.369C83.1935 139.667 87.4721 146.713 93.3104 147.108Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2116 112.78L94.3836 124.383L108.324 123.054L99.2116 112.78Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.525 163.335L137.536 163.336C150.499 164.211 161.716 154.413 162.592 141.451L162.879 137.2C163.754 124.238 153.956 113.02 140.994 112.145L140.982 112.144C128.02 111.268 116.803 121.067 115.927 134.029L115.64 138.28C114.765 151.242 124.563 162.46 137.525 163.335Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.082 151.307C141.92 151.701 147.107 145.294 147.667 136.996C148.228 128.698 143.949 121.652 138.111 121.258C132.273 120.864 127.086 127.271 126.525 135.568C125.965 143.866 130.243 150.913 136.082 151.307Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.98 116.979L137.152 128.583L151.092 127.253L141.98 116.979Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M162.433 95.143L144.238 90.5446C140.713 89.6538 137.134 91.7889 136.243 95.3135L135.859 96.8325C134.968 100.357 137.104 103.937 140.628 104.827L158.823 109.426C162.348 110.317 165.927 108.181 166.818 104.657L167.202 103.138C168.093 99.6132 165.957 96.0338 162.433 95.143Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M88.085 99.4979L106.8 97.3799C110.394 96.9732 112.978 93.7302 112.571 90.1363L112.387 88.5123C111.981 84.9185 108.737 82.3348 105.144 82.7415L86.4284 84.8595C82.8346 85.2662 80.2509 88.5092 80.6576 92.1031L80.8414 93.7271C81.2481 97.3209 84.4911 99.9046 88.085 99.4979Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.343 65.0798C123.109 20.3785 173.781 0.754294 213.809 17.1158C246.449 30.4591 267.816 66.0309 265.136 104.87C240.233 94.2299 209.621 83.475 173.911 75.6069C147.763 69.8531 123.642 66.6877 102.343 65.0798Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M129.308 55.1186C134.129 39.1085 150.249 32.5941 160.129 37.3509C167.372 40.8451 171.847 50.6935 170.375 61.2812C156.686 59.227 142.997 57.1728 129.308 55.1186Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.421 52.4531C129.738 55.3955 150.055 58.3379 170.383 61.2811C178.948 61.0913 184.682 66.0087 184.727 70.3611C184.766 73.7981 181.255 76.4418 180.354 77.0701",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M295.86 174.621L140.451 224.297L150.407 255.443L305.816 205.767L295.86 174.621Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M193.072 207.948L197.259 221.053",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M180.663 212.634L184.851 225.739",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M168.254 217.309L172.442 230.402",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.592 221.187L159.78 234.28",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M175.798 176.979C179.243 206.268 195.397 229.196 217.621 236.187C230.088 240.113 248.791 240.687 253.727 232.164C256.898 226.695 252.954 220.024 243.722 199.811C236.509 184.005 231.019 170.789 227.353 161.662",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M175.798 176.979C179.243 206.268 195.397 229.196 217.621 236.187C230.088 240.113 248.791 240.687 253.727 232.164C256.898 226.695 252.954 220.024 243.722 199.811C236.509 184.005 231.019 170.789 227.353 161.662",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.102 150.556C95.5901 150.414 73.7323 151.886 72.0653 160.009C71.3726 163.408 74.4279 166.845 76.7911 169.49C89.8552 184.144 110.989 180.34 115.813 179.344",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.102 150.556C95.5901 150.414 73.7323 151.886 72.0653 160.009C71.3726 163.408 74.4279 166.845 76.7911 169.49C89.8552 184.144 110.989 180.34 115.813 179.344",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M113.402 167.659C109.886 168.19 106.011 168.527 101.822 168.493C89.4933 168.383 79.3098 165.108 72.0286 161.849",
    stroke: "#1E1E1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilestoneHero1);
export default __webpack_public_path__ + "static/media/milestone-hero1.d8d128c1d754f7539479e94c56cd773e.svg";
export { ForwardRef as ReactComponent };